import {
  gridRowCountSelector,
  GridRowId,
  GridValidRowModel,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { Button, Indicator } from '@nexelem/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableContextProps } from '../../../context/TableContext';
import { useTableContext } from '../../../hooks/useTableContext';

export type MultiselectFooterProps = {
  readonly MultiSelectFooterProps?: FC<
    Pick<TableContextProps, 'onClearSelection'> & { selectionModel: Map<GridRowId, GridValidRowModel> }
  >;
  readonly withCancel?: boolean;
};

export const MultiselectFooter = ({
  withCancel = true,
  MultiSelectFooterProps = () => null,
}: MultiselectFooterProps) => {
  const { onClearSelection } = useTableContext();
  const apiRef = useGridApiContext();
  const totalElements = useGridSelector(apiRef, gridRowCountSelector);
  const { selectionModel } = useTableContext();
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center">
        <Indicator className="mr-1.25" count={selectionModel.size} /> / {totalElements}
        <div className="ml-10 flex items-center gap-2.5">
          <MultiSelectFooterProps selectionModel={selectionModel} onClearSelection={onClearSelection} />
          {withCancel && (
            <Button variant="text" onClick={onClearSelection}>
              {t('components.table.footer.cancel')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
